import {
  SiAtlassian,
  SiGithub,
  SiGitlab,
  SiGoogle,
  SiJira,
  SiToggl,
  SiTrello,
  SiPinterest,
  SiYcombinator,
  SiLinear,
} from "@icons-pack/react-simple-icons";
import { createElement } from "react";
import { Bitrix24Icon } from "@/components/Icons/Bitrix24Icon";

// ponytail: @icons-pack/react-simple-icons has no `SiSlack` export (Slack's
// mark isn't in the upstream simple-icons project at all, confirmed against
// the latest package). Hand-rolled here to match the package's own IconType
// shape (title/color/size, currentColor default) so it drops in identically;
// swap for a real `SiSlack` import if the package ever adds one.
const SlackIcon = ({
  title = "Slack",
  color = "currentColor",
  size = 24,
  ...props
}: {
  title?: string;
  color?: string;
  size?: string | number;
} & Record<string, unknown>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
    viewBox="0 0 24 24"
    {...props}
  >
    <title>{title}</title>
    <path d="M5.042 15.165a2.53 2.53 0 0 1-2.52 2.523A2.53 2.53 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52zm1.271 0a2.527 2.527 0 0 1 2.521-2.52a2.527 2.527 0 0 1 2.521 2.52v6.313A2.53 2.53 0 0 1 8.834 24a2.53 2.53 0 0 1-2.521-2.522zM8.834 5.042a2.53 2.53 0 0 1-2.521-2.52A2.53 2.53 0 0 1 8.834 0a2.53 2.53 0 0 1 2.521 2.522v2.52zm0 1.271a2.53 2.53 0 0 1 2.521 2.521a2.53 2.53 0 0 1-2.521 2.521H2.522A2.53 2.53 0 0 1 0 8.834a2.53 2.53 0 0 1 2.522-2.521zm10.122 2.521a2.53 2.53 0 0 1 2.522-2.521A2.53 2.53 0 0 1 24 8.834a2.53 2.53 0 0 1-2.522 2.521h-2.522zm-1.268 0a2.53 2.53 0 0 1-2.523 2.521a2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.53 2.53 0 0 1 2.523 2.522zm-2.523 10.122a2.53 2.53 0 0 1 2.523 2.522A2.53 2.53 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522zm0-1.268a2.527 2.527 0 0 1-2.52-2.523a2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.53 2.53 0 0 1-2.522 2.523z" />
  </svg>
);

export const IntegrationIcon = ({
  integration,
  defaultIcon,
  ...props
}: { integration: string; defaultIcon?: React.ComponentType } & Record<
  string,
  unknown
>) => {
  switch (integration.toLowerCase()) {
    case "google":
      return <SiGoogle {...props} />;

    case "trello":
      return <SiTrello {...props} />;

    case "jira":
      return <SiJira {...props} />;

    case "atlassian":
      return <SiAtlassian {...props} />;

    case "githubpersonal":
    case "github_personal":
    case "github":
      return <SiGithub {...props} />;

    case "gitlab":
      return <SiGitlab {...props} />;

    case "toggl":
      return <SiToggl {...props} />;

    case "pinterest":
      return <SiPinterest {...props} />;

    case "hackernews":
      return <SiYcombinator {...props} />;

    case "linear":
      return <SiLinear {...props} />;

    case "bitrix24":
      return <Bitrix24Icon {...props} />;

    case "slack":
      return <SlackIcon {...props} />;

    default:
      return defaultIcon ? createElement(defaultIcon, props) : null;
  }
};
